export default __webpack_public_path__ + "static/media/Left Side Pic.8bd4f75d.png";